import { useEffect } from 'react';

const SEO = ({
  title = 'Arikone - Digital Marketing Agency in Noida',
  description = 'Arikone: Leading digital marketing agency in Noida offering brand promotion, social media marketing, performance ads, website development, and lead generation services.',
  keywords = 'digital marketing agency noida, brand promotion, social media marketing, performance ads, website development, branding agency, lead generation, digital marketing delhi NCR',
  ogImage = window.location.origin + '/logo.png',
  url = window.location.href
}) => {
  const canonicalUrl = url.split('?')[0]; // Remove query params for canonical
  useEffect(() => {
    // Update title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    // Canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', canonicalUrl);

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Open Graph meta tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', ogImage, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:type', 'website', true);

    // Twitter Card meta tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);

    // Additional SEO tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('author', 'Arikone');
    updateMetaTag('viewport', 'width=device-width, initial-scale=1.0');

  }, [title, description, keywords, ogImage, url]);

  return null;
};

export default SEO;
